import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';
import { setToken } from '../../utils/axiosInstanse'
import { loginStore } from '../../reduser/userSlice';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import { clearNotification } from '../../reduser/notificationSlice';
import ToastNotification from '../Notification/ToastNotification'
import Button from '../CustomButton/Button'
import { Spinner } from "react-bootstrap";
import { Container } from "react-bootstrap";
import { showNotification } from '../../utils/notificationUtils';
import './login.css'
import host from "../../host";



function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [sending, setSending] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const notification = useSelector(state => state.notification);

  const handleClose = () => {
    dispatch(clearNotification());
  };

  useEffect(() => {
    if (notification.show) {
      const now = Date.now();
      const elapsedTime = now - notification.startTime;
      const remainingTime = 4000 - elapsedTime;

      if (remainingTime > 0) {
        const timer = setTimeout(() => {
          dispatch(clearNotification());
        }, remainingTime);

        return () => clearTimeout(timer);
      } else {
        dispatch(clearNotification());
      }
    }
  }, [notification, dispatch]);


  const handleLogin = (username) => {
    dispatch(loginStore(username));
  };


  const login = async (username, password) => {
    if (sending) {
      return
    }
    if (username.length !== 5) {
      showNotification(dispatch, 'Табельный номер должен состоять из 5 цифр', 'error');
      return
    }
    if (password.length < 1) {
      showNotification(dispatch, 'Введите пароль', 'error');
      return
    }
    else {
      setSending(true)
      try {
        const response = await axios.post(
          `${host}api/token/`,
          {
            username: username,
            password: password
          },
          {
            withCredentials: true
          }
        );
        if (response.status === 200) {
          const { access } = response.data;
          setToken(access);
          handleLogin(username);
          showNotification(dispatch, `Вы вошли как: ${username}`, 'success');
          setSending(false)
          navigate('/note/new');
        }
      } catch (error) {
        setSending(false)
        if (error.response?.status === 401) {
          showNotification(dispatch, error.response.data.error, 'error');
        }
        else {
          showNotification(dispatch, 'Ошибка сервера', 'error');
        }
      }
    }
  };

  return (
    <Container fluid className="cont-lg d-flex justify-content-center align-items-center">
      <Form
        className="form-container shadow-lg p-4 rounded"
        onSubmit={(e) => {
          e.preventDefault();
          login(username, password);
        }}
      >
        <h2 className="text-center mb-4">Добро пожаловать!</h2>
        <p className="help-login-text text-center">
          Для входа ваша учётная запись должна быть активирована
          администратором.
        </p>

        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Табельный номер</Form.Label>
          <Form.Control
            type="text"
            placeholder="Введите табельный номер"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
          <Form.Label>Пароль</Form.Label>
          <Form.Control
            type="password"
            placeholder="Введите пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>

        <div className="mb-3 text-end">
          <button
            onClick={() => navigate("/note/recovery_pass")}
            type="button"
            className="link-button"
          >
            Забыли пароль?
          </button>
        </div>

        <div className="buttons-login ">
          {sending ? (
            <Button
              type="submit"
              className="btn-outline w-45"
            >
              <Spinner animation="border" role="status" className="custom-spinner" />
            </Button>
          ) : (
            <Button type="submit"
              className="btn-outline w-45" >
              Вход
            </Button>
          )}

          <Button
            onClick={() => navigate("/note/register")}
            className="btn-outline w-45"
          >
            Регистрация
          </Button>
        </div>
      </Form>
      {notification?.show && (
        <ToastNotification
          show={notification.show}
          message={notification.message}
          onClose={handleClose}
          type={notification.type}
        />
      )}
    </Container>
  );
}

export default Login;